module.exports = __webpack_public_path__ + "img/Multi-account-5.846f4149.png";